import { Flex, Text, Button } from '@chakra-ui/react';
import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonIcon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SearchInput
} from '@morressier/alembic';

interface PdfToolbarProps {
  page: number;
  pages: number;
  scale: number;
  onPageChange: (page: number) => void;
  setScale: (scale: number) => void;
  search: string;
  setSearch: (value: string) => void;
}

export function PdfToolbar({
  page,
  pages,
  scale,
  onPageChange,
  setScale,
  search,
  setSearch
}: PdfToolbarProps) {
  return (
    <Flex
      align="center"
      justify="space-between"
      px={3}
      py={2}
      borderBottom="1px solid"
      borderColor="gray.200"
      bg="white"
      flexWrap={{ base: 'wrap', md: 'nowrap' }}
      gap={{ base: 2, md: 0 }}
    >
      <SearchInput
        placeholder="Search"
        value={search}
        name="search"
        onInputClear={() => setSearch('')}
        onChange={e => setSearch(e.target.value)}
        width={{ base: '100%', md: '260px' }}
        size="sm"
      />
      <Flex align="center" gap={3} flex={{ base: '1 1 100%', md: 'initial' }} justifyContent={{ base: 'center', md: 'flex-end' }}>
        <ButtonIcon
          size="small"
          ariaLabel="Prev"
          icon={<FontAwesomeIcon icon={faChevronLeft} />}
          isDisabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        />

        <Text fontSize="sm" minW="48px" textAlign="center">
          {page} / {pages}
        </Text>

        <ButtonIcon
          size="small"
          ariaLabel="Next"
          icon={<FontAwesomeIcon icon={faChevronRight} />}
          isDisabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
        />

        <Menu ariaLabel="switch zoom" size="sm">
          <MenuButton
            as={Button}
            size="sm"
            rightIcon={<FontAwesomeIcon icon={faChevronDown} />}
          >
            {Math.round(scale * 100)}%
          </MenuButton>
          <MenuList>
            {[50, 75, 100, 125, 150, 200,225,250,300].map(v => (
              <MenuItem
                key={v}
                onClick={() => setScale(v / 100)}
                ariaLabel={`zoom ${v}`}
              >
                {v}%
              </MenuItem>
            ))}
          </MenuList>
        </Menu>

        <ButtonIcon
          size="small"
          ariaLabel="Zoom out"
          icon={<FontAwesomeIcon icon={faMagnifyingGlassMinus} />}
          onClick={() => setScale(Math.max(scale - 0.2, 0.5))}
        />

        <ButtonIcon
          size="small"
          ariaLabel="Zoom in"
          icon={<FontAwesomeIcon icon={faMagnifyingGlassPlus} />}
          onClick={() => setScale(Math.min(scale + 0.2, 3))}
        />
      </Flex>
    </Flex>
  );
}
